import ArtShopBuyButton from './ArtShopBuyButton';
import ArtShopBuyButtonContainer from './ArtShopBuyButton.container';
export default ArtShopBuyButtonContainer(ArtShopBuyButton);
//# sourceMappingURL=index.js.map